import React from 'react'
import App from './App'

export default function DirectorsAccounts({ appProps, screenClass, accounts, pagination, title, description, labels }) {
  function formatDate(value) {
    if (!value) return '-'

    return new Date(value).toLocaleString()
  }

  function renderEmail(email) {
    return (
      <div key={ email.id } className='director-pill'>
        <div className='director-pill-line'>
          <span>{ email.email || '-' }</span>
          { email.searchPath && (
            <a href={ email.searchPath } className='director-icon-link' title={ labels.viewEmail }>
              <i className='fa-light fa-eye'></i>
            </a>
          ) }
        </div>
        { email.primary && <strong>{ labels.primary }</strong> }
        { email.unconfirmed && <strong>{ labels.unconfirmed }</strong> }
      </div>
    )
  }

  function renderTenant(tenant) {
    return (
      <div key={ tenant.id } className='director-tenant-row'>
        <div>
          <strong>{ tenant.flavor || '-' }</strong>
          <span>{ tenant.tenantUid }</span>
        </div>
        <div className='director-role'>
          { tenant.role }
          { tenant.platform && <span>{ tenant.platform }</span> }
        </div>
      </div>
    )
  }

  function renderPaginationItems() {
    let lastNumber = null

    return pagination.pages.map(page => {
      const showGap = lastNumber && page.number > lastNumber + 1
      lastNumber = page.number

      return (
        <React.Fragment key={ page.number }>
          { showGap && <span className='director-pagination-gap'>...</span> }
          <a
            href={ page.path }
            className={ `director-page-link ${page.current ? 'active' : ''}` }>
            { page.number }
          </a>
        </React.Fragment>
      )
    })
  }

  return (
    <App appProps={ appProps }>
      <div className={ screenClass }>
        <div className='director-shell'>
          <section className='director-header'>
            <div>
              <span>{ labels.eyebrow }</span>
              <h1>{ title }</h1>
              <p>{ description }</p>
            </div>
          </section>

          <section className='director-table'>
            <div className='director-table-head'>
              <div>{ labels.account }</div>
              <div>{ labels.emails }</div>
              <div>{ labels.flavorsAndRoles }</div>
              <div>{ labels.activity }</div>
            </div>

            { accounts.map(account => (
              <article key={ account.id } className='director-account-row'>
                <div className='director-account-main'>
                  <strong>{ account.fullName || account.uid }</strong>
                  <div className='director-inline-link'>
                    <span>{ labels.uid } { account.uid }</span>
                    { account.showPath && (
                      <a href={ account.showPath } className='director-icon-link' title={ labels.viewAccount }>
                        <i className='fa-light fa-eye'></i>
                      </a>
                    ) }
                  </div>
                  { account.superadmin && <em>{ labels.superadmin }</em> }
                  { account.confirmed && <em>{ labels.confirmed }</em> }
                </div>

                <div className='director-email-list'>
                  { account.emails.length ? account.emails.map(renderEmail) : <span className='director-empty'>{ labels.noEmails }</span> }
                </div>

                <div className='director-tenant-list'>
                  { account.tenants.length ? account.tenants.map(renderTenant) : <span className='director-empty'>{ labels.noFlavors }</span> }
                </div>

                <div className='director-activity'>
                  <span>{ labels.created } { formatDate(account.createdAt) }</span>
                  <span>{ labels.lastSignIn } { formatDate(account.lastSignInAt) }</span>
                </div>
              </article>
            )) }

            { !accounts.length && (
              <div className='director-empty-state'>
                { labels.noAccounts }
              </div>
            ) }
          </section>

          { pagination.totalPages > 1 && (
            <div className='director-pagination'>
              <a className='director-page-jump' href={ pagination.firstPath }>
                { labels.firstPage }
              </a>
              <div className='director-page-list'>
                { renderPaginationItems() }
              </div>
              <a className='director-page-jump' href={ pagination.lastPath }>
                { labels.lastPage }
              </a>
            </div>
          ) }
        </div>
      </div>
    </App>
  )
}
